import { Fragment } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { deleteFromCart } from "../../../store/slices/cart-slice";
import { useTranslation } from "react-i18next";

const MenuCart = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  const { coupon } = useSelector((state) => state.coupon);

  return (
    <div className="shopping-cart-content">
      {cartItems && cartItems.length > 0 ? (
        <Fragment>
          <ul>
            {cartItems.map((item) => {
              return (
                <li className="single-shopping-cart" key={item.cartItemId}>
                  <div className="shopping-cart-img">
                    <Link to={"/product/" + item.id}>
                      <img
                        alt="product-img"
                        src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                          item.img
                        }`}
                        loading="lazy"
                        className="img-fluid rounded h-100 object-fit-cover"
                      />
                    </Link>
                  </div>
                  <div className="shopping-cart-title">
                    <h4>
                      <Link to={"/product/" + item.id}>
                        {i18n.language === "ar" ? item.name : item.name_en}
                      </Link>
                    </h4>
                    <h6>
                      {t("quantity")} : {item.quantity_in_cart}
                    </h6>
                    <span>
                      {item?.price}{" "}
                      {i18n?.language == "ar"
                        ? import.meta.env.VITE_REACT_APP_CURRENCY
                        : import.meta.env.VITE_REACT_APP_CURRENCY_EN}
                    </span>
                  </div>
                  <div className="shopping-cart-delete">
                    <button
                      onClick={() => dispatch(deleteFromCart(item.cartItemId))}
                    >
                      <i className="fa fa-times-circle" />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
          <div className="shopping-cart-total">
            <h4 className="d-flex justify-content-between align-items-center fw-bold">
              {t("total")}:{" "}
              <span className="shop-total">
                {coupon?.code
                  ? (
                      cartItems.reduce((total, product) => {
                        const quantity = product.quantity_in_cart ?? 1;
                        const price = product.price ?? 0;
                        return total + price * quantity;
                      }, 0) *
                      ((100 - coupon?.discount) / 100)
                    ).toFixed(2)
                  : cartItems
                      .reduce((total, product) => {
                        const quantity = product.quantity_in_cart ?? 1;
                        const price = product.price ?? 0;
                        return total + price * quantity;
                      }, 0)
                      .toFixed(2)}{" "}
                {i18n?.language == "ar"
                  ? import.meta.env.VITE_REACT_APP_CURRENCY
                  : import.meta.env.VITE_REACT_APP_CURRENCY_EN}{" "}
              </span>
            </h4>
          </div>
          <div className="shopping-cart-btn btn-hover text-center">
            <Link className="default-btn" to={"/cart"}>
              {t("view")} {t("cart")}
            </Link>
            <Link className="default-btn" to={"/checkout"}>
              {t("checkout")}
            </Link>
          </div>
        </Fragment>
      ) : (
        <div className="d-flex justify-content-center align-items-center gap-1 flex-column">
          <svg
            width="45px"
            height="45px"
            viewBox="-1.92 -1.92 35.84 35.84"
            id="svg5"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:svg="http://www.w3.org/2000/svg"
            fill="#ca1818"
            stroke="#ca1818"
            strokeWidth="0.00032"
          >
            <g
              id="SVGRepo_bgCarrier"
              strokeWidth={0}
              transform="translate(0,0), scale(1)"
            >
              <path
                transform="translate(-1.92, -1.92), scale(1.12)"
                d="M16,28.841738620152075C17.80140383839349,28.29049253520953,19.504846186753277,27.61373303274665,21.156807465796675,26.708221040730763C22.746401977544075,25.836894992662963,24.338054509707085,24.96455223600739,25.543383285986014,23.610594210478958C26.780444705842967,22.220990584937276,27.622793569208866,20.552335818355793,28.208849908113542,18.786590321335698C28.82871912550922,16.918969059182924,29.33768502952255,14.967369882981306,29.058614334687825,13.019456493529836C28.771416389368643,11.01481489745863,27.769440930251086,9.200221119247109,26.598709576569497,7.547811156192738C25.39037158568554,5.842321909155112,24.04365408340815,4.113062504072649,22.1388156949017,3.2526178599225446C20.24423521568095,2.3968068703429863,18.041319550803344,2.3666866157145714,16,2.760211880008381C14.09493066051549,3.1274708498368136,12.439924208777215,4.232819127427777,10.904183718417595,5.418428458292453C9.541432364643198,6.470488185066377,8.981656602674013,8.295536987057629,7.5642462366132275,9.272710858534454C5.441896554514767,10.735875447380717,1.8577145968993625,10.221937618348118,0.6404983729712903,12.494293983745804C-0.44923817399138555,14.5286653061276,1.191323789095058,17.097705799515293,2.2837161100138346,19.13065229077208C3.263934540270192,20.95484272153131,5.500089262433725,21.747757849009947,6.566634825591953,23.522857694200432C7.840040951279522,25.642244895886517,6.906865143663971,29.19539561605915,9.060623263788969,30.409764271618503C11.152557819099005,31.58927450989102,13.70356675147904,29.544468241683255,16,28.841738620152075"
                fill="#f2f2f2"
              />
            </g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#CCCCCC"
              strokeWidth="5.76"
            />
            <g id="SVGRepo_iconCarrier">
              <defs id="defs2" />

              <g id="layer1" transform="translate(-108,-244)">
                <path
                  d="m 112.62891,255.00586 c -1.62528,0 -2.86287,1.51426 -2.58789,3.10156 l 2.27539,13.13672 c 0.27852,1.60786 1.69977,2.76172 3.3125,2.76172 h 16.76757 c 1.61437,0 3.01297,-1.16098 3.31055,-2.74805 a 1.0001,1.0001 0 0 0 0.002,-0.0137 L 137.75,259.46289 a 1,1 0 0 0 -0.81445,-1.1543 1,1 0 0 0 -1.1543,0.81446 l -2.03906,11.76757 c -0.12254,0.65349 -0.68047,1.11524 -1.34571,1.11524 h -16.76757 c -0.66689,0 -1.23318,-0.46326 -1.34375,-1.10156 l -2.27539,-13.13672 c -0.0738,-0.42571 0.20139,-0.76172 0.61914,-0.76172 H 128 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z"
                  id="path43319"
                  style={{
                    color: "#ca1818",
                    fill: "#ca1818",
                    fillRule: "evenodd",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "4.1",
                  }}
                />

                <path
                  d="m 119.30469,246.07227 a 1,1 0 0 0 -0.55664,0.52734 l -4,9 a 1,1 0 0 0 0.50781,1.32031 1,1 0 0 0 1.32031,-0.50781 l 4,-9 a 1,1 0 0 0 -0.50781,-1.32031 1,1 0 0 0 -0.76367,-0.0195 z"
                  id="path43321"
                  style={{
                    color: "#ca1818",
                    fill: "#ca1818",
                    fillRule: "evenodd",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "4.1",
                  }}
                />

                <path
                  d="m 127.95508,246.0918 a 1,1 0 0 0 -0.50586,1.32031 l 2.0918,4.70703 a 1,1 0 0 0 1.31835,0.50781 1,1 0 0 0 0.50782,-1.32031 l -2.0918,-4.70703 a 1,1 0 0 0 -1.32031,-0.50781 z"
                  id="path43323"
                  style={{
                    color: "#ca1818",
                    fill: "#ca1818",
                    fillRule: "evenodd",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "4.1",
                  }}
                />

                <path
                  d="m 124,259.00586 a 1,1 0 0 0 -1,1 v 8 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -8 a 1,1 0 0 0 -1,-1 z"
                  id="path43325"
                  style={{
                    color: "#ca1818",
                    fill: "#ca1818",
                    fillRule: "evenodd",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "4.1",
                  }}
                />

                <path
                  d="m 120,259.00586 a 1,1 0 0 0 -1,1 v 8 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -8 a 1,1 0 0 0 -1,-1 z"
                  id="path43327"
                  style={{
                    color: "#ca1818",
                    fill: "#ca1818",
                    fillRule: "evenodd",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "4.1",
                  }}
                />

                <path
                  d="m 128,262.00586 a 1,1 0 0 0 -1,1 v 5 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -5 a 1,1 0 0 0 -1,-1 z"
                  id="path43329"
                  style={{
                    color: "#ca1818",
                    fill: "#ca1818",
                    fillRule: "evenodd",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "4.1",
                  }}
                />

                <path
                  d="m 133,250.00586 c -3.30186,0 -6,2.69814 -6,6 0,3.30186 2.69814,6 6,6 3.30186,0 6,-2.69814 6,-6 0,-3.30186 -2.69814,-6 -6,-6 z m 0,2 c 2.22098,0 4,1.77902 4,4 0,2.22098 -1.77902,4 -4,4 -2.22098,0 -4,-1.77902 -4,-4 0,-2.22098 1.77902,-4 4,-4 z"
                  id="circle43331"
                  style={{
                    color: "#ca1818",
                    fill: "#ca1818",
                    fillRule: "evenodd",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "4.1",
                  }}
                />

                <path
                  d="m 131.58594,253.5918 a 1,1 0 0 0 -0.70703,0.29297 1,1 0 0 0 0,1.41406 l 0.70703,0.70703 -0.70703,0.70703 a 1,1 0 0 0 0,1.41406 1,1 0 0 0 1.41406,0 L 133,257.41992 l 0.70703,0.70703 a 1,1 0 0 0 1.41406,0 1,1 0 0 0 0,-1.41406 l -0.70703,-0.70703 0.70703,-0.70703 a 1,1 0 0 0 0,-1.41406 1,1 0 0 0 -0.70703,-0.29297 1,1 0 0 0 -0.70703,0.29297 L 133,254.5918 l -0.70703,-0.70703 a 1,1 0 0 0 -0.70703,-0.29297 z"
                  id="path43333"
                  style={{
                    color: "#ca1818",
                    fill: "#ca1818",
                    fillRule: "evenodd",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "4.1",
                  }}
                />
              </g>
            </g>
          </svg>

          <p className="text-center">{t("cart_empty")}!</p>
        </div>
      )}
    </div>
  );
};

export default MenuCart;
